// Mindshine Billing's own web page (ADR 0021): its sign-in page (its name, icon and colour; its identity
// provider), the app full-bleed, and over it the one speed dial holding the companions of the SDKs it pins
// from their vendored `./app` entries. No bar, no host chrome: who is signed in, About and Sign out are the
// app's own UI (its account menu).
import '@cortex/app-shell/csp-nonce';
import { mountApp } from '@cortex/app-shell';
import './styles.css';
import { appCompanion as access } from '@cortex/sdk-access-shell/app';

void mountApp([access]);
